import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SectionSourceType } from 'enums-lib';
import { ISection } from 'interfaces-lib';
import { SectionComponentBase } from '../../../../sections/section-component-base';

export class FixedFileConfig {
  required: boolean;
  optional: boolean;
  saveBackToDataSource: boolean;

  constructor(
    required: boolean,
    optional?: boolean,
    saveBackToDataSource?: boolean,
  ) {
    this.required = required;
    this.optional = optional;
    this.saveBackToDataSource = saveBackToDataSource ?? false;
  }

  static clone(config: FixedFileConfig): FixedFileConfig {
    return new FixedFileConfig(
      config.required,
      config.optional,
      config.saveBackToDataSource ?? false,
    );
  }
}

@Component({
  selector: 'app-fixed-file-section',
  templateUrl: './fixed-file-section.component.html',
  styleUrls: ['./fixed-file-section.component.scss'],
  standalone: false,
})
export class FixedFileSectionComponent extends SectionComponentBase {
  @Input() workflowConfigId: string;
  @Input() section: FormGroup;
  @Input() entityType: string;
  @Input() namespace: string;
  @Input() combinedOutput = false;

  get config(): FormGroup {
    return this.section?.get('config') as FormGroup;
  }

  public static override buildForm(formGroup: UntypedFormGroup, section?: ISection): void {
    const config = section?.config
      ? FixedFileConfig.clone(section.config as FixedFileConfig)
      : new FixedFileConfig(false);

    formGroup.get('required').setValue(config.required ?? false);
    formGroup.get('sourceType').setValue(SectionSourceType.S3);
    formGroup.get('referenceId').setValue(section?.referenceId ?? 'FIXED_FILE_1');
    formGroup.get('sourceValue').addValidators(Validators.required);
    formGroup.addControl('file', new FormControl(''));

    const configGroup = new UntypedFormGroup({
      required: new UntypedFormControl(config.required ?? false),
      optional: new UntypedFormControl(config.optional ?? false),
      saveBackToDataSource: new UntypedFormControl(config.saveBackToDataSource ?? false),
    });
    formGroup.setControl('config', configGroup);
  }
}
